import { Button, Screen, Text, TextInput } from "components"
import React, { useEffect, useState } from "react"
import { TouchableOpacity, View } from "react-native"
import { style } from "./styles"
import { useNavigation, useRoute } from "@react-navigation/native"
import { translate } from "i18n"
import { Controller, useForm } from "react-hook-form"
import validator from "validator"
import {
  CodeField,
  useBlurOnFulfill,
  useClearByFocusCell,
} from "react-native-confirmation-code-field"
import { colors, typography } from "theme"
import flash from "config/flash"
import { useStores } from "models"
import { useColor } from "app/theme/getThemes"

export const EmployeeEnterUserScreen = () => {
  const { companyTheme } = useColor()
  const route = useRoute()
  const navigation = useNavigation<any>()
  const { userStore } = useStores()

  const [isLoading, setIsLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const [otpInput, setOtpInput] = useState<string>("")
  const [counter, setCounter] = useState(0)
  const [role, setRole] = useState(null)

  const [joinUser, setJoinUser] = useState(false)

  const ref = useBlurOnFulfill({ value: otpInput, cellCount: 6 })
  const [props, getCellOnLayoutHandler] = useClearByFocusCell({
    value: otpInput,
    setValue: (e) => {
      setOtpInput(e)
    },
  })
  const { control, handleSubmit, clearErrors, setValue, getValues, watch } = useForm({
    reValidateMode: "onSubmit",
  })
  useEffect(() => {
    if (role !== "user") {
      const interval = setInterval(() => {
        if (counter > 0) {
          setCounter((prevCounter) => prevCounter - 1)
        }

        if (counter === 0) {
          clearInterval(interval)
        }
      }, 1000)

      return () => {
        clearInterval(interval)
      }
    }
  }, [role, counter])

  const clickJoinUser = async () => {
    const phoneNumber = getValues("phoneNumber")

    setLoading(true)

    await fetch(`${process.env.API_URL}/api/member`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
      body: JSON.stringify({
        contact_number: `6${phoneNumber}`,
        status: "unregister",
      }),
    })
      .then(async (data) => {
        const response = await data.json()
        console.log(response)

        if (data?.ok) {
          sentOTP()
        } else {
          console.log("error user", data)
          setLoading(false)
        }
      })
      .catch(() => {
        flash("error", translate("verificationScreen.resendOTPFailed"))
      })
  }

  const sentOTP = async () => {
    const phoneNumber = getValues("phoneNumber")

    await fetch(`${process.env.API_URL}/api/client/otp/6${phoneNumber}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        configure_name: "whatsapp",
        company_code: process.env.COMPANY_CODE,
      }),
    })
      .then((data) => {
        if (data?.ok) {
          setJoinUser(true)
          setRole("newUser")
          setCounter(60)
          setLoading(false)
        } else {
          flash("error", translate("verificationScreen.verifyFailed"))
        }
      })
      .catch((error) => {
        console.log("error", error)
      })
  }

  const onResendOTP = async () => {
    setCounter(60)

    // await fetch(`${process.env.API_URL}/api/client/otp/6${phoneNumber}`, {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    // })
    //   .then((data) => {
    //     if (data?.ok) {
    //       flash("success", translate("verificationScreen.resendOTPSuccess"))
    //       setCounter(60)
    //     } else {
    //       flash("error", translate("verificationScreen.resendOTPFailed"))
    //     }
    //   })
    //   .catch(() => {
    //     flash("error", translate("verificationScreen.resendOTPFailed"))
    //   })
  }

  const verifyOtp = async () => {
    const phoneNumber = getValues("phoneNumber")

    console.log(phoneNumber)
    await fetch(`${process.env.API_URL}/api/client/verifyotp/6${phoneNumber}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        otp_no: otpInput,
        company_code: process.env.COMPANY_CODE,
      }),
    })
      .then((data) => {
        if (data?.ok) {
          flash("success", translate("verificationScreen.verifySuccess"))
          navigation.navigate("employeeUploadReceipt")
        } else {
          flash("error", translate("verificationScreen.verifyFailed"))
        }
      })
      .catch(() => {
        flash("error", translate("verificationScreen.resendOTPFailed"))
      })
  }

  const onSubmit = async (data) => {
    if (role) {
      console.log("test", data)
    } else {
      setValue("phoneNumber", data.phoneNumber)
      setIsLoading(true)

      await fetch(`${process.env.API_URL}/api/member/check/6${data?.phoneNumber}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${userStore?.accessToken}`,
        },
      })
        .then(async (res) => {
          const response = await res.json()
          if (response[0]?.is_verified) {
            setIsLoading(false)
            navigation.navigate("employeeUploadReceipt", { state: response })
          } else if (response[0]?.is_verified === false) {
            sentOTP()
            setIsLoading(false)
          } else {
            setIsLoading(false)
            console.log("new user", response)
            setJoinUser(true)
          }
        })
        .catch((e) => {
          flash("error", translate("errors.failedToUpdateProfile"))
          console.error("catch error", e)
        })
    }
  }

  const goBack = () => {
    navigation.goBack()
  }

  return (
    <Screen>
      <View style={style.container}>
        <Text style={style.titleText}>{translate("employeeEnterUserScreen.header")}</Text>
        <Controller
          name="phoneNumber"
          control={control}
          rules={{
            required: translate("errors.required"),
            validate: (value) =>
              validator.isMobilePhone(value, "ms-MY")
                ? null
                : translate("errors.invalidPhoneNumber"),
          }}
          render={({ field: { onChange, value }, fieldState: { error } }) => {
            return (
              <>
                <TextInput
                  onFocus={() => clearErrors("phoneNumber")}
                  keyboardType="numeric"
                  value={value}
                  onChangeText={onChange}
                  error={error}
                  title={translate("loginScreen.phoneNumber")}
                  errorMessage={error?.message}
                  placeholder={translate("loginScreen.phoneNumberPlaceholder")}
                  containerStyle={style.phoneNumberInputContainer}
                  style={style.phoneNumberInputStyle}
                />
              </>
            )
          }}
        />

        {role && joinUser ? (
          <>
            <View style={style.otpContainer}>
              <Text
                style={{
                  fontFamily: typography.primary.normal,
                  marginBottom: 20,
                  width: "100%",
                }}
              >
                {translate("verificationScreen.headerTitle")}
              </Text>
              <CodeField
                ref={ref}
                {...props}
                value={otpInput}
                onChangeText={setOtpInput}
                cellCount={4}
                rootStyle={style.rootStyle}
                keyboardType="number-pad"
                renderCell={({ index, symbol, isFocused }) => (
                  <Text
                    key={index}
                    style={[style.cell, isFocused && style.focusCell]}
                    onLayout={getCellOnLayoutHandler(index)}
                  >
                    {symbol}
                  </Text>
                )}
              />
            </View>

            <View style={style.resentContainer}>
              <Text>{translate("verificationScreen.didntReceiveCode")}</Text>
              <TouchableOpacity onPress={() => onResendOTP()} disabled={counter > 0}>
                <Text
                  style={{
                    color: counter > 0 ? colors.placeholder : companyTheme.first,
                    fontFamily: typography.primary.normal,
                  }}
                >
                  {translate("verificationScreen.resend")}{" "}
                  {counter > 0 && `${translate("verificationScreen.in")} 00:${counter}`}
                </Text>
              </TouchableOpacity>
            </View>
          </>
        ) : null}

        {joinUser && role !== "newUser" ? (
          <>
            <View style={style.otpContainer}>
              <Text
                style={{
                  fontFamily: typography.primary.normal,
                  marginBottom: 20,
                  width: "100%",
                }}
              >
                {translate("employeeEnterUserScreen.joinUser")}
              </Text>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-around",
                  width: "100%",
                }}
              >
                <Button
                  disabled={isLoading}
                  loading={isLoading}
                  onPress={() => {
                    clickJoinUser()
                  }}
                  style={{ width: "45%" }}
                  title={translate("common.yes")}
                />
                <Button
                  disabled={isLoading}
                  loading={isLoading}
                  onPress={() => {
                    setJoinUser(false)
                    navigation.goBack()
                  }}
                  style={{
                    width: "45%",
                    backgroundColor: "white",
                    borderColor: colors.primary,
                    borderRadius: 10,
                    borderWidth: 3,
                    padding: 10,
                    textAlign: "center",
                  }}
                  title={translate("common.no")}
                  titleStyle={style.modalButton}
                />
              </View>
            </View>
          </>
        ) : (
          <View style={{ marginVertical: 5 }}>
            <Button
              disabled={isLoading}
              loading={isLoading}
              onPress={role ? verifyOtp : handleSubmit(onSubmit)}
              style={style.loginButton}
              title={translate("common.submit")}
            />
          </View>
        )}
        <View style={style.buttonContainer}>
          <Button
            onPress={goBack}
            style={style.backButton}
            titleStyle={style.modalButton}
            title={translate("common.back")}
          />
        </View>
      </View>
    </Screen>
  )
}
